// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
export enum OperatorType {
  Emissions = 'Emissions', // 排出事業者
  Collects = 'Collects', // 回収・配送事業者
  Recycle = 'Recycle', // リサイクル事業者
  Compressions = 'Compressions', // 圧縮事業者
  Admin = 'Admin', // 圧縮事業者
  Separates = 'Separates',
  Brand = 'Brand',
  Purchase = 'Purchase',
  Producer = 'Producer', // 製品化
  AdminPool = 'AdminPool', // pool管理者
}

export enum IdType {
  Emissions = 'emissions',
  Collects = 'collects',
  Recycle = 'recycle',
  Separate = 'separate',
  Compressions = 'compressions',
  Resource = 'resource',
}

export enum RoleType {
  AdminOperator = 'AdminOperator',
  AdminSite = 'AdminSite',
  UserNormal = 'UserNormal',
  BrandOwner = 'BrandOwner',
  AdminRecotech = 'AdminRecotech',
  AdminPool = 'AdminPool',
  AdminTenant = 'AdminTenant',
}

export enum ModalType {
  add = 'add',
  update = 'update',
}

export enum OperatorMenuItem {
  Emissions = '排出',
  Collects = '回収',
  Compressions = '中間処理',
  Recycle = 'リサイクル',
  Purchase = '調達',
  Producer = '製品化',
  None = '',
}

export enum AdminManagementType {
  operator = 'operator',
  site = 'site',
}

export enum TenantAuthen {
  None = 'None',
  ICCard = 'ICCard',
  Barcode = 'BarCode',
}

export enum PrintLabel {
  QRCode = 'QRCode',
  NoneQRCode = 'NoneQRCode',
}

export enum ItemSize {
  LARGE = 'Large',
  MEDIUM = 'Medium',
  SMALL = 'Small',
}

export enum DateTypeRange {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
}

export enum SiteOption {
  GRADE = 'grade',
  SITE_TYPE = 'siteType',
  PROVINCE = 'province',
}

export enum ColorsPaletteKeys {
  PURCHASE_MATERIAL_CHART = 'purchaseMaterialChart',
  PURCHASE_MATERIAL_FLOW = 'purchaseMaterialFlow',
  TENANT_DASHBOARD_CHARTS = 'tenantDashboardCharts',
}

export enum StorageKeys {
  COLORS_SETTING = 'colorsSettingV2',
  COLLECTING_SESSION = 'collectingRouteSessions',
  COLLECT_MAP_VIEW_MODE_STORAGE_KEY = 'collectMapViewMode',
}

export enum ImportStatus {
  success = 'Success',
  fail = 'Fail',
  no_updates = 'No updates',
}

export enum OverallRank {
  high = 'High',
  medium = 'Medium',
  low = 'Low',
}

export enum ScaleType {
  TANAKA = 'Tanaka',
  ISHIDA = 'Ishida',
  NONE = 'None',
}

export enum SubSiteResourceStatuses {
  UnReceive = 'UnReceive',
  Received = 'Received',
}

export enum EdiWeightType {
  EmissionWeight = 'EmissionWeight',
  ReceivedWeight = 'ReceivedWeight',
}

export enum EmissionWasteUnitKind {
  WASTE = 'Waste',
  GENERAL = 'General',
  WASTE_PAPER = 'WastePaper',
}

export enum ProcessingMode {
  Manual = 'Manual',
  Auto = 'Auto',
}

export enum DashboardsPoolResourcesExportJobStatus {
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum CollectRenewError {
  RENEW_FAILED = 'renew_failed',
  MAX_RETRY_EXCEEDED = 'max_retry_exceeded',
}

export enum NoticeContent {
  TooFew = 'TooFew',
  TooMany = 'TooMany',
  Nothing = 'Nothing',
  NotSeparated = 'NotSeparated',
  Other = 'Other',
}

export enum CollectStatus {
  Collected = 'Collected',
  UnCollect = 'UnCollect',
}

export enum BookingQRType {
  Emission = 'Emission',
  Resource = 'Resource',
  General = 'General',
}

export enum CollectDeliveryStatus {
  Delivering = 'Delivering',
  Completed = 'Completed',
}
